export default __webpack_public_path__ + "static/media/preview—iphoneX-right.e2d07924.png";